import React from "react";
import { Mail, MapPin, Building2 } from "lucide-react";
import { MarketingNav, MarketingFooter } from "@/components/marketing/MarketingChrome";
import { EnterpriseEnquiry } from "@/components/marketing/PricingTable";
import { MARKETING } from "@/lib/marketingContent";

const C = MARKETING.company;

export default function Contact() {
  return (
    <div className="marketing-root min-h-screen bg-white" data-testid="contact-page">
      <MarketingNav active="Contact" />
      <main className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
        <p className="overline-label">Contact us</p>
        <h1 className="mt-3 font-marketing-display text-4xl font-black tracking-tight sm:text-5xl lg:text-6xl">
          Let’s talk about your delivery
        </h1>
        <p className="mt-5 max-w-2xl text-base text-[color:var(--marketing-text-muted)]">
          Send us a message and we will respond within one working day. For privacy, data protection or
          contractual matters, use the same address below.
        </p>

        <div className="mt-14 grid grid-cols-1 gap-10 lg:grid-cols-3">
          <div className="space-y-8" data-testid="contact-company-details">
            <div>
              <p className="overline-label inline-flex items-center gap-2"><Building2 size={13} strokeWidth={1.5} /> Registered company</p>
              <p className="mt-3 text-sm font-semibold text-[color:var(--marketing-text)]" data-testid="contact-company-name">{C.name}</p>
              <p className="mt-1 text-sm text-[color:var(--marketing-text-muted)]" data-testid="contact-company-number">
                Company number {C.number}
              </p>
              <p className="mt-1 text-sm text-[color:var(--marketing-text-muted)]">{C.jurisdiction}</p>
            </div>
            <div>
              <p className="overline-label inline-flex items-center gap-2"><MapPin size={13} strokeWidth={1.5} /> Registered office</p>
              <address className="mt-3 space-y-0.5 text-sm not-italic text-[color:var(--marketing-text-muted)]" data-testid="contact-company-address">
                {C.addressLines.map((l) => <div key={l}>{l}</div>)}
              </address>
            </div>
            <div>
              <p className="overline-label inline-flex items-center gap-2"><Mail size={13} strokeWidth={1.5} /> Email</p>
              <a href={`mailto:${C.email}`} data-testid="contact-email-link"
                className="mt-3 block text-sm font-semibold text-[color:var(--marketing-primary)] hover:underline">
                {C.email}
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <EnterpriseEnquiry
              heading="Send us a message"
              blurb="Tell us a little about your organisation and what you need, and we will come back to you with the right next step — a demo, a quote or an assurance pack for your IT team."
            />
          </div>
        </div>
      </main>
      <MarketingFooter />
    </div>
  );
}
